module.exports = __webpack_public_path__ + "static/media/copyCheckout.d531cefe.svg";